<template>
  <div class="myMenupage">
    <!-- 菜单导航 :style="{width:(num>0?'auto':'100%')}" -->
    <div
      class="myMenu flexBetween"
      :class="{ myMenu2: num > 0 }"
      v-if="is_show"
    >
      <div class="myMenu-left">
        <router-link to="../home">
          <img src="../../static/img/logo-colours.svg" alt="" width="98" />
          <img src="../../static/img/logo-colours.svg" alt="" width="98" />
          <!-- <img src="../../static/img/logo-lucency.svg" alt="" width="98" /> -->
        </router-link>
      </div>

      <div class="isreturn" v-if="isReturn">
        <router-link to="" @click.native="$router.back(-1)" class="flexItems">
          <img src="../../static/img/fanhui.png" width="11" alt="" />返回
        </router-link>
      </div>

      <div class="indexTitle" v-if="cnName != ''">
        <p class="flexItems"><span></span>{{ cnName }}</p>
        <p>{{ enName }}</p>
      </div>

      <div class="menu-right flex">
        <div class="download">
					<router-link to="../download">下载</router-link>
				</div>
        <div class="myMenu-submit flexItems flexCenter">
          <span class="qiye">登录企业端</span>
          <div class="banben flexItems">
            <a :href="'https://ship.huoyunjh.com'" target="_blank">水运版</a>
            <a :href="'https://truck.huoyunjh.com'" target="_blank">汽运版</a>
          </div>
        </div>
        <div class="myMenu-menu" @click="changeisClose1(true)">
          <!-- <img src="../../static/img/menu-black.svg" alt="" />
          <img src="../../static/img/menu-black.svg" alt="" /> -->
          <img src="../../static/img/menu-white.svg" alt="" />
          <img src="../../static/img/menu-white.svg" alt="" />
        </div>
      </div>
    </div>
    <!-- 菜单框 -->
    <div
      class="myMenuBox-mask"
      :style="[
        { top: this.$store.state.isClose1 ? '0px' : '-100%' },
        { right: this.$store.state.isClose1 ? '10%' : '-100%' },
        {
          transform: this.$store.state.isClose1
            ? 'matrix(4, 0, 0, 4, 0, 0)'
            : 'matrix(1, 0, 0, 1, 0, 0)',
        },
      ]"
      @touchmove.prevent.stop
      @mousewheel.prevent
    ></div>
    <div
      class="myMenuBox transition-box"
      v-if="this.$store.state.isClose2"
      @touchmove.prevent.stop
      @mousewheel.prevent
    >
      <div class="myMenu flexBetween">
        <div class="myMenu-left"></div>
        <div class="nbsp">&nbsp;</div>
        <div class="menu-right flex">
          <div class="myMenu-menu-close" @click="changeisClose1(false)">
            <img src="../../static/img/close.png" alt="" />
          </div>
        </div>
      </div>
      <div class="myMenu-navBox flexCenter">
        <div class="myMenuBox-li flexCenter">
          <router-link to="../home" class="myMenuBox-li-title">
            <p class="flexCenter"><span></span>首页</p>
            <p>Home</p>
          </router-link>
        </div>
        <div class="myMenuBox-li flexCenter">
          <router-link
            to=""
            class="myMenuBox-li-title"
            @click.native="isNav = !isNav"
          >
            <p class="flexCenter"><span></span>关于我们</p>
            <p>About us</p>
          </router-link>
          <div class="myMenuBox-li-li">
            <router-link to="../about">货运江湖</router-link>
            <router-link to="../develop">发展历程</router-link>
            <router-link to="../friend">合作伙伴</router-link>
            <router-link to="../myimage">企业形象</router-link>
          </div>
        </div>
        <div class="myMenuBox-li flexCenter">
          <router-link to="" class="myMenuBox-li-title">
            <p class="flexCenter"><span></span>产品中心</p>
            <p>Product Center</p>
          </router-link>
          <div class="myMenuBox-li-li">
            <router-link to="../advantage">平台优势</router-link>
            <router-link to="../brief">平台简介</router-link>
            <router-link to="../taxation">税务相关</router-link>
            <router-link to="../chain">产业生态链</router-link>
          </div>
        </div>
        <div class="myMenuBox-li flexCenter">
          <router-link to="../news" class="myMenuBox-li-title">
            <p class="flexCenter"><span></span>资讯中心</p>
            <p>News</p>
          </router-link>
        </div>
        <div class="myMenuBox-li flexCenter">
          <router-link to="../contact" class="myMenuBox-li-title">
            <p class="flexCenter"><span></span>联系我们</p>
            <p>Contact us</p>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      scroll: false, //判断鼠标滚动
      isNav: false, //关闭打开二级导航
      num: 0,
      is_show: true, //决定导航 显示隐藏
    };
  },
  props: ["cnName", "enName", "isReturn"],
  computed: {
    isFollow() {
      return this.$store.state.isClose1;
    },
  },
  watch: {
    isFollow(newVal, oldVal) {
      if (newVal == true) {
        setTimeout(() => {
          this.$store.commit("myIsClose2", true);
        }, 400);
      } else {
        setTimeout(() => {
          this.$store.commit("myIsClose2", false);
        }, 100);
      }
    },
  },
  mounted() {
    if (document.addEventListener) {
      //firefox
      window.addEventListener("scroll", this.handleScroll);
    }
    window.onmousewheel = document.onmousewheel = this.handleScroll; //ie chrome
  },
  methods: {
    // 监听页面滚动
    handleScroll(e) {
      e = e || window.event;
      if (this.$route.name == "newsdetail") {
        this.num = 1;
      } else {
        this.num = document.documentElement.scrollTop;
      }

      if (e.wheelDelta) {
        //判断浏览器IE，谷歌滑轮事件
        if (e.wheelDelta > 0) {
          //当滑轮向上滚动时
          this.is_show = true;
        }
        if (e.wheelDelta < 0) {
          //当滑轮向下滚动时
          this.is_show = false;
        }
      } else if (e.detail) {
        //Firefox滑轮事件
        if (e.detail > 0) {
          //当滑轮向上滚动时
          this.is_show = true;
        }
        if (e.detail < 0) {
          //当滑轮向下滚动时
          this.is_show = true;
        }
      }
      if (document.documentElement.scrollTop == 0) {
        this.is_show = true;
      }
    },
    changeisClose1(bool) {
      this.$store.commit("myIsClose1", bool);
    },
    changeisClose2() {
      this.$store.commit("myIsClose2", true);
    },
  },
};
</script>
<style scoped="scoped">
.myMenu {
  position: fixed;
  top: 0;
  width: 100%;
  height: 108px;
  background: rgba(0, 0, 0, 0);
  padding: 16px 80px;
  z-index: 99;
  align-items: center;
}
.myMenu-submit {
  min-width: 140px;
  color: #000;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  transition: 0.3s;
  /*font-family: "fontRegular";*/
}
.myMenu-menu {
  margin-left: 80px;
  cursor: pointer;
}
.myMenu-menu img {
  width: 48px;
}
.myMenu-menu img:nth-of-type(1) {
  display: block;
}
.myMenu-menu img:nth-of-type(2) {
  display: none;
}
.myMenu-menu-close img {
  width: 36px;
}
.myMenu2 {
  background-color: #fff;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.08);
  transition: 0.5s;
}
.myMenu2 .myMenu-submit {
  color: #282828;
  font-weight: 700;
}

.myMenu2 .myMenu-menu img:nth-of-type(1) {
  display: none;
}
.myMenu2 .myMenu-menu img:nth-of-type(2) {
  display: block;
}

.myMenu-left img:nth-of-type(1) {
  display: none;
}
.myMenu-left img:nth-of-type(2) {
  display: block;
}

.myMenu2 .myMenu-left img:nth-of-type(1) {
  display: block;
}
.myMenu2 .myMenu-left img:nth-of-type(2) {
  display: none;
}

.myMenuBox {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 100000000000;
  display: flex;
  flex-flow: column;
  -ms-flex-flow: column;
}
.myMenuBox-mask {
  position: fixed;
  width: 60%;
  height: 100%;
  top: -100%;
  right: -100%;
  z-index: 99999999999;
  background-color: #197ffd;
  border-radius: 50%;
  padding-top: 60%;
  transform: matrix(1, 0, 0, 1, 0, 0);
  transition: 0.8s;
}
.myMenuBox .myMenu {
  position: static;
}
.myMenu-navBox {
  width: 100%;
  flex: 1;
}
.myMenuBox-li {
  width: 330px;
  height: 100%;
  transition: 0.3s;
  margin: 0px 14px;
  flex-flow: column;
  -ms-flex-flow: column;
}
.myMenuBox-li:hover .myMenuBox-li-li {
  height: 40%;
}
.myMenuBox-li-title {
  display: block;
}
.myMenuBox-li-title p:nth-of-type(1) {
  font-size: 34px;
  color: #fff;
}
.myMenuBox-li-title p:nth-of-type(1) span {
  display: block;
  width: 34px;
  height: 4px;
  background-color: #fff;
  margin-right: 9px;
}
.myMenuBox-li-title p:nth-of-type(2) {
  font-size: 20px;
  color: rgba(254, 254, 255, 0.4);
  /* text-align: center; */
  margin-top: 15px;
  padding-left: 43px;
}
.myMenuBox-li-li {
  display: flex;
  display: -ms-flexbox;
  flex-flow: column;
  -ms-flex-flow: column;
  justify-content: center;
  height: 0;
  overflow: hidden;
  transition: all 0.3s;
}
.myMenuBox-li-li a {
  display: inline;
  text-align: center;
  font-size: 22px;
  color: #fff;
  margin-top: 30px;
}
.banben {
  display: none;
  transition: 0.3s;
}
.banben a {
  color: #000;
  margin: 0px 10px;
}
.myMenu2 .banben a {
  color: #232526;
}
.myMenu-submit:hover .qiye {
  display: none;
}
.myMenu-submit:hover .banben {
  display: block;
}

.myMenu-menu-close {
  cursor: pointer;
}

.indexTitle {
  display: none;
}
.download > a{
	/*font-family: 'fontRegular';*/
	margin: 10px;
	color:#282828;
	font-weight: 700;
	display: block;
}
@media only screen and (max-width: 1440px) {
}

@media only screen and (max-width: 750px) {
  .myMenu {
    padding: 23px;
    height: auto;
    width: auto;
    right: 0;
  }
  .myMenu-menu {
    margin-left: 0;
  }
  .myMenu-menu img {
    width: 36px;
  }
  .myMenu-menu img:nth-of-type(1) {
    display: none;
  }
  .myMenu-menu img:nth-of-type(2) {
    display: block;
  }
  .myMenu2 {
    background-color: rgba(255, 255, 255, 0);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
  .myMenu-left,
  .myMenu-submit {
    display: none;
  }
  .download {
		display: none;
	}
  .indexTitle,
  .nbsp,
  .nbspLogo {
    display: block;
  }

  .myMenu-navBox {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    /* overflow-y: auto; */
  }
  .myMenuBox-li {
    width: auto;
    height: auto;
    margin: 15px 0;
    min-width: 113px;
  }
  .myMenuBox-li:hover .myMenuBox-li-li {
    height: 100%;
  }
  .myMenuBox-li-title p:nth-of-type(1) {
    font-size: 22px;
    justify-content: flex-start;
  }
  .myMenuBox-li-title p:nth-of-type(1) span {
    width: 16px;
    height: 3px;
  }
  .myMenuBox-li-title p:nth-of-type(2) {
    font-size: 12px;
    margin-top: 0px;
    padding-left: 25px;
  }
  .myMenuBox-li-li a {
    font-size: 13px;
    margin-top: 13px;
  }
  .myMenuBox-li-title {
    width: 100%;
  }
}

@media only screen and (max-width: 750px) {
  .myMenupage {
    /* overflow: hidden; */
    width: 100%;
    height: auto;
    background-color: #fff;
    position: sticky;
    top: 0;
    z-index: 999;
  }
  .myMenu {
    position: static;
  }
  .indexTitle {
    display: block;
    position: static;
    padding: 0;
  }

  .isreturn a {
    color: #999999;
    font-size: 12px;
  }
  .isreturn a img {
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/myMenu_page.vue